import React, { useState } from "react";
import { Alert, Box, Typography, Button, Paper } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import CircularProgress from "@mui/material/CircularProgress";
import { axios_tenant } from "../../../../../axios";

const TemplateStep = ({ onNext, onBack, configValues = {} }) => {

  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  const downloadTemplate = async () => {
    setError(null);
    setLoading(true);
    try {
      const { type, action } = configValues;
      const res = await axios_tenant.get("/adim/template-url", {
        params: { type, action }
      });
      const url = res.data?.url;
      if (!url) throw new Error("No URL returned from server.");
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.rel = "noopener noreferrer";
      a.click();
    } catch (err) {
      console.error(err);
      setError("Failed to fetch the template. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Paper sx={{ p: 4, background: "#fff" }}>
        <Typography variant="h5" sx={{ mb: 1 }}>
          Download Excel Template
        </Typography>

        <Typography variant="body2" color="textSecondary" sx={{ mb: 3 }}>
          Download the template for{" "}
          <strong>{configValues.type}</strong> —{" "}
          <strong>{configValues.action}</strong>. Fill it in and upload it in the next step.
        </Typography>

        <Button
          variant="contained"
          startIcon={loading ? <CircularProgress size={16} sx={{ color: "inherit" }} /> : <DownloadIcon />}
          onClick={downloadTemplate}
          disabled={loading}
        >
          {loading ? "Fetching…" : "Download Template"}
        </Button>

        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </Paper>

      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
        <Button variant="contained" onClick={onNext}>
          Continue
        </Button>
      </Box>
    </Box>
  );
};

export default TemplateStep;
